import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardContent, CardHeader, CardTitle } from '../../components/UI'
import { materialCalculatorApi } from '../../services/materialCalculator'

export default function MCProjectListPage() {
  const navigate = useNavigate()
  const [projects, setProjects] = useState([])
  const [query, setQuery] = useState('')
  const [type, setType] = useState('')
  const [country, setCountry] = useState('')

  useEffect(() => { materialCalculatorApi.listProjects().then(setProjects).catch(() => setProjects([])) }, [])

  const filtered = useMemo(() => projects.filter((p) =>
    (!query || p.name.toLowerCase().includes(query.toLowerCase())) &&
    (!type || p.projectType === type) &&
    (!country || p.countryCode === country)
  ), [projects, query, type, country])

  const duplicateProject = async (id) => {
    const created = await materialCalculatorApi.duplicateProject(id)
    setProjects((prev) => [created, ...prev])
  }

  const removeProject = async (id) => {
    await materialCalculatorApi.deleteProject(id)
    setProjects((prev) => prev.filter((p) => p.id !== id))
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">Proyectos</h1>
        <Button onClick={() => navigate('/material-calculator/projects/new')}>Nuevo proyecto</Button>
      </div>

      <Card>
        <CardContent className="grid grid-cols-1 md:grid-cols-3 gap-2">
          <input className="rounded-lg border px-3 py-2 text-sm" placeholder="Buscar por nombre" value={query} onChange={(e) => setQuery(e.target.value)} />
          <select className="rounded-lg border px-3 py-2 text-sm" value={type} onChange={(e) => setType(e.target.value)}>
            <option value="">Tipo</option><option value="casa">Casa</option><option value="apartamento">Apartamento</option><option value="torre">Torre</option><option value="otro">Otro</option>
          </select>
          <input className="rounded-lg border px-3 py-2 text-sm" placeholder="País" value={country} onChange={(e) => setCountry(e.target.value.toUpperCase())} />
        </CardContent>
      </Card>

      <Card>
        <CardHeader><CardTitle>Listado</CardTitle></CardHeader>
        <CardContent>
          <div className="overflow-x-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50"><tr><th className="px-3 py-2 text-left">Nombre</th><th className="px-3 py-2">Tipo</th><th className="px-3 py-2">País</th><th className="px-3 py-2">Último cálculo</th><th className="px-3 py-2">Estado</th><th className="px-3 py-2">Acciones</th></tr></thead>
              <tbody>
                {filtered.map((p) => (
                  <tr className="border-t" key={p.id}>
                    <td className="px-3 py-2">{p.name}</td>
                    <td className="px-3 py-2 text-center">{p.projectType}</td>
                    <td className="px-3 py-2 text-center">{p.countryCode}</td>
                    <td className="px-3 py-2 text-center">{p.lastCalculatedAt ? new Date(p.lastCalculatedAt).toLocaleString() : '—'}</td>
                    <td className="px-3 py-2 text-center">{p.status === 'calculated' ? 'Calculado' : 'Borrador'}</td>
                    <td className="px-3 py-2">
                      <div className="flex flex-wrap gap-1 justify-center">
                        <Button size="sm" variant="outline" onClick={() => navigate(`/material-calculator/projects/${p.id}`)}>Ver</Button>
                        <Button size="sm" variant="outline" onClick={() => navigate(`/material-calculator/projects/${p.id}/wizard`)}>Asistente</Button>
                        <Button size="sm" variant="outline" onClick={() => navigate(`/material-calculator/projects/${p.id}/reports`)}>Reportes</Button>
                        <Button size="sm" variant="secondary" onClick={() => duplicateProject(p.id)}>Duplicar</Button>
                        <Button size="sm" variant="danger" onClick={() => removeProject(p.id)}>Eliminar</Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
